<template>
  <div class="div_login_number">
    <h3 class="h3_title">手机号登录</h3>
    <p class="p_explain" v-if="newObj.mobile?.length != 11">
      新用户获取验证码，自动登录
    </p>
    <p class="p_explain" v-else>
      你正在登录账号 +86 {{ maskPhoneNumber(newObj.mobile) }}
    </p>
    <div class="div_input_body">
      <InputPhone
        ref="phone"
        class="input_phone"
        v-model="newObj.mobile"
      ></InputPhone>
      <InputCode
        v-if="loginType == 0"
        ref="code"
        v-model="newObj.sms_secret"
        :disabled="newObj.mobile?.length != 11"
        :getCode="openVerify"
      ></InputCode>
      <InputPassworld
        v-else
        v-model="newObj.passworld"
        ref="passworld"
      ></InputPassworld>
      <div class="flex_between other_login">
        <span
          class="change_type cp_us hover_color"
          @click="clickChangeType(loginType == 1 ? 0 : 1)"
          >{{ loginType == 1 ? "验证码登录" : "密码登录" }}</span
        >
        <span class="hover_color cp_us" @click="clickForget">忘记密码?</span>
      </div>
    </div>
    <el-button
      class="butsubmit"
      :class="canSubmit() ? 'btnGroupOne' : 'btnGroupNone'"
      @click="clickSubmit"
    >
      登录 / 注册
    </el-button>
    <div class="div_bottom flex_center">
      <Radio v-model="privacy"></Radio>
      <p>
        已阅读并同意
        <a :href="agreement.uagreem" target="_blank" class="hover_color_t"
          >《服务协议》</a
        >
        和
        <a :href="agreement.pp" target="_blank" class="hover_color_t"
          >《隐私政策》</a
        >
      </p>
    </div>
    <el-button class="wx-login phone_none" @click="router.replace({ name: 'wxLogin' })">
      <i class="iconfont">&#xe714;</i>
      微信登录
    </el-button>

    <VerifyDialog ref="verifyDialogRef" @verifySuccess="getCode"></VerifyDialog>
  </div>
</template>

<script setup>
import { ref } from "vue";
import md5 from "js-md5";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";

import Radio from "@/components/input/radio.vue";
import InputPhone from "@/components/input/inputPhone.vue";
import InputCode from "@/components/input/inputCode.vue";
import InputPassworld from "@/components/input/inputPassworld.vue";
import VerifyDialog from "@/components/modal/verifyDialog.vue";

import { setLocalStor, goBackToSource } from "@/utils/index";

import {
  sendValidateCode,
  loginByValidateCode,
  checkMobileExists,
  loginByPassword,
} from "@/api/api.js";

const router = useRouter();
const agreement = {
  uagreem: process.env.VUE_APP_HELP_REDIRECT + "servicearg/uagreem.html",
  pp: process.env.VUE_APP_HELP_REDIRECT + "servicearg/pp.html",
};

let loginType = ref(0); //0验证码登录 1微信登录

// --表单--
let privacy = ref(false);
let newObj = ref({
  mobile: "",
  sms_key: "",
  sms_secret: "", //验证码
  passworld: "", //密码
  verifyEd: false, // 是否校验
});
let getCodeCallback = null;
// --ref---
const newOlder = ref(null);
let phone = ref(null);
let code = ref(null);
let passworld = ref(null);
let verifyDialogRef = ref(null); // 校验弹窗

function openVerify(callback){
  getCodeCallback = callback;
  if(newObj.value.verifyEd){
    getCode()
  }else {
    verifyDialogRef.value.openDialog();
  }
}
// 点击获取验证码
function getCode() {
  newObj.value.verifyEd = true;
  if (newObj.value.mobile.length == "") {
    phone.value.worring = true;
    ElMessage({
      message: "请输入手机号",
      type: "error",
    });
    return;
  } else if (newObj.value.mobile.length != 11) {
    phone.value.worring = true;
    ElMessage({
      message: "请输入正确的手机号",
      type: "error",
    });
    return;
  }
  sendValidateCode(newObj.value.mobile, 1).then(() => {
    getCodeCallback(true);
    ElMessage({
      message: "验证码已发送",
      type: "message",
    });
  });
}
// 切换登录类型
function clickChangeType(type) {
  newObj.value.sms_secret = "";
  newObj.value.passworld = "";
  loginType.value = type;
}
// 忘记密码
function clickForget() {
  let { href } = router.resolve({
    name: "forgetPassworld",
  });
  window.open(href, "_blank");
}
// 验证
function verification() {
  let isOk = true;
  let worrIng = "";

  // let regExp = /^1[3456789]\d{9}$/;
  // if (!regExp.test(newObj.value.mobile)) {
  //   phone.value.worring = true;
  //   ElMessage({
  //     message: "手机号格式错误",
  //     type: "error",
  //   });
  //   return false;
  // }
  if (loginType.value == 0) {
    // 验证码登录
    if (newObj.value.mobile == "") {
      isOk = false;
      phone.value.worring = true;
      worrIng = "请输入手机号";
    } else if (newObj.value.mobile.length != 11) {
      isOk = false;
      phone.value.worring = true;
      worrIng = "请输入正确的手机号";
    } else if (newObj.value.sms_secret == "") {
      isOk = false;
      code.value.worring = true;
      worrIng = "请输入验证码";
    }
  } else {
    //密码登录
    if (newObj.value.mobile == "") {
      isOk = false;
      phone.value.worring = true;
      worrIng = "请输入手机号";
    } else if (newObj.value.mobile.length != 11) {
      isOk = false;
      phone.value.worring = true;
      worrIng = "请输入正确的手机号";
    } else if (newObj.value.passworld == "") {
      isOk = false;
      passworld.value.worring = true;
      worrIng = "请输入密码";
    }
  }
  if (isOk && privacy.value == false) {
    isOk = false;
    worrIng = "请同意下方服务协议和隐私政策";
  }
  if (!isOk)
    ElMessage({
      message: worrIng,
      type: "error",
    });
  return isOk;
}
function canSubmit() {
  let isok = false;
  if (
    privacy.value &&
    newObj.value.mobile != "" &&
    (newObj.value.sms_secret?.length == 6 || newObj.value.passworld != "")
  ) {
    isok = true;
  }
  return isok;
}
// 点击登录注册
function clickSubmit() {
  if (!verification()) return;
  switch (loginType.value) {
    case 0:
      keyLogin();
      break;

    default:
      numberLogin();
      break;
  }
}
// 验证码登录
function keyLogin() {
  // 判断新老用户
  checkMobileExists(newObj.value.mobile).then((resUser) => {
    newOlder.value = resUser.data;
    loginByValidateCode(newObj.value.mobile, newObj.value.sms_secret, 1).then(
      (res) => {
        if (res.code == 200) {
          if (newOlder.value) {
            ElMessage({
              icon: "SuccessFilled",
              type: "success",
              message: "登录成功",
            });
            //直接进入中台
            setTimeout(() => {
              goBackToSource(res.data);
              setLocalStor("userLogin", {
                token: res.data,
                phone: newObj.value.mobile,
              });
            }, 500);
          } else {
            setLocalStor("userLogin", {
              token: res.data,
              phone: newObj.value.mobile,
            });
            ElMessage({
              message: "请将个人信息补充完整",
              type: "message",
            });
            // 补充个人信息
            router.replace({ name: "setMessage" });
          }
        } else {
          ElMessage({
            type: "warning",
            message: "验证码错误",
          });
        }
      }
    );
  });
}
// 账号密码登录
function numberLogin() {
  loginByPassword(newObj.value.mobile, md5(newObj.value.passworld)).then(
    (res) => {
      if (res.code == 200) {
        ElMessage({
          icon: "SuccessFilled",
          type: "success",
          message: "登录成功",
        });
        setTimeout(() => {
          localStorage.clear();
          goBackToSource(res.data);
        }, 1000);
      } else if (res.code == 323) {
        ElMessage({
          type: "warning",
          message: "该账号未设置密码",
        });
      } else if (res.code == 308) {
        ElMessage({
          type: "warning",
          message: "该账号未注册",
        });
      } else if (res.code == 320) {
        ElMessage({
          type: "warning",
          message: "账号或密码不正确",
        });
      }
    }
  );
}

function maskPhoneNumber(phoneNumber) {
  // 提取前3位和后2位
  const start = phoneNumber.substring(0, 3);
  const end = phoneNumber.substring(8, 11);
  // 中间插入星号
  return `${start}******${end}`;
}
</script>

<style lang='scss' scoped>
.div_login_number {
  font-size: 0;
  box-sizing: border-box;
  text-align: center;
  margin-top: -60px;
  .h3_title {
    line-height: 50px;
    font-weight: 600;
    font-size: 36px;
    color: #222222;
  }
  .p_explain {
    line-height: 22px;
    font-weight: 500;
    font-size: 16px;
    color: #999999;
    margin: 15px 0px 30px;
  }
  .div_input_body {
    width: 400px;
    max-width: 100%;
    text-align: left;
    .input_phone {
      margin-bottom: 20px;
    }
    .other_login {
      margin-top: 12px;
      font-size: 14px;
      color: #1f2328;
      line-height: 22px;
      font-size: 16px;
      color: #999999;
      .change_type {
        color: #666666;
      }
      .hover_color {
        &:hover {
          color: $subject-color-t-hover !important;
        }
      }
    }
  }
  .butsubmit {
    width: 100%;
    height: 60px;
    margin: 48px 0px 20px;
    border-radius: 15px;
    font-weight: 500;
    font-size: 16px;
  }
  .btnGroupOne {
    background-color: #333333;
  }
  .div_bottom {
    p {
      font-weight: 500;
      font-size: 14px;
      color: #999999;
      a {
        text-decoration: none;
      }
    }
    .hover_color_t {
      color: #333333 !important;
    }
  }
}

.wx-login {
  width: 100%;
  height: 60px;
  margin-top: 58px;
  color: #ffffff;
  background: $subject-color-t;
  font-size: 16px;
  border-radius: 16px;
  border: 2px solid $subject-color-t;
  box-sizing: border-box;
  i {
    font-size: 18px;
    margin-right: 12px;
  }
}
@media screen and (max-width: 768px) {
  .div_login_number {
    width: 100%;
    height: 100%;
    padding: 20% 0.2rem 0;
    margin-top: 0;
    .h3_title {
      line-height: 0.4rem;
      font-size: 0.3rem;
    }
    .p_explain {
      line-height: 0.2rem;
      font-size: 0.16rem;
      margin: 0.1rem 0px 0.2rem;
    }
    .div_input_body {
      width: 100%;
      .input_phone {
        margin-bottom: 0.2rem;
      }
      .other_login {
        margin-top: 0.1rem;
        font-size: 0.14rem;
        line-height: 0.2rem;
        font-size: 0.16rem;
      }
    }
    .butsubmit {
      width: 100%;
      height: 0.6rem;
      margin: 0.2rem 0px 0.2rem;
      border-radius: 0.15rem;
      font-size: 0.16rem;
    }
    .div_bottom {
      p {
        font-size: 0.14rem;
      }
    }
  }
  .wx-login {
    width: 100%;
    height: 0.6rem;
    margin-top: 0.3rem;
    font-size: 0.16rem;
    border-radius: 0.16rem;
    border: 0.02rem solid $subject-color-t;
    i {
      font-size: 0.18rem;
      margin-right: 0.1rem;
    }
  }
}
</style>
